import { render } from "./ModalInvoicesAbort.vue?vue&type=template&id=52db07f1"
import script from "./ModalInvoicesAbort.vue?vue&type=script&lang=js"
export * from "./ModalInvoicesAbort.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__